import type { TarjetaAyuda } from '../../marco/cabecera';

/** Textos de «Web pública» (13.1 a 13.5) y sus tarjetas de la «?». */
export const AYUDA_TU_WEB: readonly TarjetaAyuda[] = [
    { icono: 'globe', titulo: 'Tu web', texto: 'Todo lo que cambias va al borrador. Tus clientes no ven nada hasta que publicas.' },
    { icono: 'languages', titulo: 'Idiomas', texto: 'Los textos van por idioma. Lo que no traduzcas sale en el idioma principal.' },
    { icono: 'eye', titulo: 'Vista previa', texto: 'El enlace privado enseña siempre el borrador actual y caduca en 24 horas.' },
];

export const AYUDA_WIDGETS: readonly TarjetaAyuda[] = [
    { icono: 'code', titulo: 'Widgets', texto: 'Trozos de Reservaria para pegar en otra web: reservar, pedir cita, comprar entradas o escribir.' },
    { icono: 'shield-check', titulo: 'Dónde se puede ver', texto: 'Solo en las webs que añadas (sin https://). En las demás no se enseña.' },
];

export const AYUDA_MEDICION: readonly TarjetaAyuda[] = [
    { icono: 'chart-line', titulo: 'Sin cookies', texto: 'Contamos impresiones, clics y ventas por día, sin datos de quien visita.' },
    { icono: 'trending-up', titulo: 'Conversiones', texto: 'Reservas, citas y entradas que salen de tu web o tus widgets, menos las anuladas.' },
];

export const TEXTO_BORRADOR_CAMBIADO = 'Otra persona ha cambiado el borrador mientras tanto. Lo hemos vuelto a cargar: revisa y guarda otra vez.';

/** Al menos un catálogo provisional (G574): lo dice la pantalla de añadir secciones y la de nuevo widget. */
export const CATALOGO_PROVISIONAL = 'Catálogo provisional (G574): el equipo lo está validando.';
